import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export type AnalyticsObject = {
  id: number;
  email: string;
  name: string;
  joined_on: string;
  last_note_created_on: string;
  total_number_of_notes_created: number;
  number_of_intakes_created_per_month: number;
  number_of_clients_created_per_month: number;
  number_of_ongoing_clients: number;
  average_time_per_session: null | number;
};

export type DiagnosesBreakdown = {
  name: string;
  value: number;
};

type ListResponse<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  tagTypes: ["Analytics"],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Token ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getUserAnalytics: build.query<
      ListResponse<AnalyticsObject>,
      { page?: number; search?: string; ordering?: string; pageSize?: number; start_date?: string; end_date?: string }
    >({
      query: ({
        page,
        search,
        ordering,
        pageSize,
        start_date,
        end_date,
      }: {
        page?: number;
        search?: string;
        ordering?: string;
        pageSize?: number;
        start_date?: string;
        end_date?: string;
      } = {}) =>
        `/analytics/therapist_table/?${search ? `search=${encodeURIComponent(search)}&` : ""}${
          ordering ? `ordering=${encodeURIComponent(ordering)}&` : ""
        }${pageSize ? `page_size=${pageSize}&` : ""}${start_date ? `start_date=${encodeURIComponent(start_date)}&` : ""}${
          end_date ? `end_date=${encodeURIComponent(end_date)}&` : ""
        }page=${page || ""}`,

      providesTags: (result) =>
        result
          ? [
              ...result.results.map(({ id }) => ({
                type: "Analytics" as const,
                id,
              })),
              { type: "Analytics", id: "PARTIAL-LIST" },
            ]
          : [{ type: "Analytics", id: "PARTIAL-LIST" }],
    }),
    getDiagnosesBreakdown: build.query<DiagnosesBreakdown[], void>({
      query: () => `/analytics/diagnoses_breakdown/`,
    }),
  }),
});

export const { useGetUserAnalyticsQuery, useGetDiagnosesBreakdownQuery } = analyticsApi;
